import Bookmark from "../assets/image/bookmark.png"

const Responsive = ({ children }) => {
    
    return(
        <div className="responsive-wrapper">
            <img src={Bookmark} alt="bookmark-image" /> 
            <div className="info">
                <p>
                Hi! <br />
                This site <br />
                doesn't support <br />
                mobile sizes yet, <br /> 
                please be patient. <br /> 
                Thanks!
                </p>
            </div>
        </div>
    );
}

export default Responsive;